// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__35bSz","title":"Images45_title__17YpT","images":"Images45_images__1DK6p"};